export enum PaymentStatus {
  Pending = 1,
  Completed = 2,
  Canceled = 3,
  Rejected = 4,
  Failed = 5
}
